import NormeFormController from './norme.form.controller';

export default {
    template: require('./norme.form.html'),
    controller: NormeFormController
};
